"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeDedupedPageStates = exports.getDuplicatesKey = exports.dedupePageStates = exports.createFingerprintsAsync = exports.calculateOverview = exports.assignNodeLabels = exports.appendIsNewIssueToRawResults = exports.MAX_LENGTH = void 0;
const appendIsNewIssueToRawResults_1 = require("./appendIsNewIssueToRawResults");
Object.defineProperty(exports, "appendIsNewIssueToRawResults", { enumerable: true, get: function () { return appendIsNewIssueToRawResults_1.appendIsNewIssueToRawResults; } });
const assignNodeLabels_1 = require("./assignNodeLabels");
Object.defineProperty(exports, "assignNodeLabels", { enumerable: true, get: function () { return assignNodeLabels_1.assignNodeLabels; } });
const calculateOverview_1 = require("./calculateOverview");
Object.defineProperty(exports, "calculateOverview", { enumerable: true, get: function () { return calculateOverview_1.calculateOverview; } });
const createFingerprintsAsync_1 = require("./createFingerprintsAsync");
Object.defineProperty(exports, "createFingerprintsAsync", { enumerable: true, get: function () { return createFingerprintsAsync_1.createFingerprintsAsync; } });
const watcherDedupe_1 = require("./watcherDedupe");
Object.defineProperty(exports, "dedupePageStates", { enumerable: true, get: function () { return watcherDedupe_1.dedupePageStates; } });
Object.defineProperty(exports, "getDuplicatesKey", { enumerable: true, get: function () { return watcherDedupe_1.getDuplicatesKey; } });
Object.defineProperty(exports, "mergeDedupedPageStates", { enumerable: true, get: function () { return watcherDedupe_1.mergeDedupedPageStates; } });
var generateNodeLabel_1 = require("./generateNodeLabel");
Object.defineProperty(exports, "MAX_LENGTH", { enumerable: true, get: function () { return generateNodeLabel_1.MAX_LENGTH; } });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map